module.exports = __webpack_public_path__ + "media/images/application/icons/icon-circle-right-543461dd4a27ac50c84a96003daf3bd1.svg";